import Layout from "../Shared/Layout";

const QuoteSummaryDetailPage = (props) => {
    const { formShowData, getSizeTypeDetails, handleChange, formData, handleNext, onContactUs, setFormData } = props;

    return (
        // <Layout>
        <div className="quote_summary_detail_page">
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <div className="quote_summary_detail">
                            <h2 className="quote_summary_heading">Quote Summary</h2>
                            <div className="quote_summary_info">
                                {formShowData?.map((item, i) => (
                                    <p key={i}><b>{item?.label} -</b> {item?.value}</p>
                                ))}
                            </div>
                            <div className="row justify-content-center">
                                {getSizeTypeDetails?.map((item, i) => {
                                    return (
                                        <div className="col-md-6" key={i}
                                         onClick={() => {
                                            // Handle checkbox selection
                                            const isSelected = formData.selectedSizeDetailIds.includes(item.id);
                                            if (isSelected) {
                                                // Remove from array
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    selectedSizeDetailIds: prev.selectedSizeDetailIds.filter(id => id !== item.id),
                                                }));
                                            } else {
                                                // Add to array
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    selectedSizeDetailIds: [...prev.selectedSizeDetailIds, item.id],
                                                }));
                                            }
                                        }}
                                        
                                        >
                                            <div className="option_box">
                                                <ul>
                                                    <li>{item?.details}</li>
                                                </ul>
                                                <p className="text-center">Option No. {i + 1}</p>
                                            </div>
                                            <div className="option_box_input" key={item.id}>
                                                <input
                                                    type="checkbox"
                                                    name="selectedSizeDetailIds"
                                                    value={item.id}
                                                    checked={formData.selectedSizeDetailIds.includes(item.id)}
                                                    onChange={() => { }}
                                                />
                                            </div>
                                        </div>
                                    )

                                })}
                            </div>
                            <div className="free_quote_btn">
                                <button onClick={handleNext}>Get Your Free Quote</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 mt-md-auto mt-4" style={{ position: 'relative' }}>
                        <img src="../images/Vectoronimg.png" alt="" className="Vectoronimg" />
                        <div className="quote_summary_img">
                            <h2 className="quote_summary_heading1">Get Club Membership</h2>
                            <p className="quote_summary_img_p">We’re a tech company bringing a breath of fresh air to HVAC, ensuring homeowners get the trusted help they deserve</p>
                            <div className="quote_add_membership">
                                <button onClick={() => onContactUs('club-membership')}>Add Membership</button>
                            </div>
                            {/* <p className="clun_member_save">Add Our Club Membership to save15%</p> */}
                            <div className="quote_summary_imgs" style={{ position: 'relative', width: "100%" }}>
                                <img src="../images/quote_summary.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // </Layout>
    )
}

export default QuoteSummaryDetailPage;